import { Component } from '@angular/core';
import { RidDemoPage } from '../../../components/rid-demo-page/rid-demo-page';
import { RidEggCarton } from '../../../components/rid-egg-carton/rid-egg-carton';

@Component({
  selector: 'app-egg-carton-page',
  imports: [RidDemoPage, RidEggCarton],
  templateUrl: './egg-carton-page.html',
})
export class EggCartonPage {}
